import { Box, Button, Typography } from '@mui/material'
import { LeftArrowIcon, RightArrowIcon } from 'src/v3/core/icons'

interface WeekNavigationProps {
  weekDisplayText: string
  canGoBack: boolean
  canGoForward: boolean
  onPreviousWeek: () => void
  onNextWeek: () => void
  isLoading?: boolean
}

export let WeekNavigation = ({
  weekDisplayText,
  canGoBack,
  canGoForward,
  onPreviousWeek,
  onNextWeek,
  isLoading = false,
}: WeekNavigationProps) => (
  <Box
    component="nav"
    aria-label="Week navigation"
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      mb: 3,
    }}
  >
    <Button
      variant="outlined"
      startIcon={<LeftArrowIcon aria-hidden="true" />}
      onClick={onPreviousWeek}
      disabled={!canGoBack || isLoading}
      aria-label="Go to previous week"
      aria-disabled={!canGoBack || isLoading}
    >
      Previous Week
    </Button>

    <Typography
      variant="h6"
      component="h2"
      id="current-week-display"
      aria-live="polite"
      aria-atomic="true"
    >
      {weekDisplayText}
    </Typography>

    <Button
      variant="outlined"
      endIcon={<RightArrowIcon aria-hidden="true" />}
      onClick={onNextWeek}
      disabled={!canGoForward || isLoading}
      aria-label="Go to next week"
      aria-disabled={!canGoForward || isLoading}
    >
      Next Week
    </Button>
  </Box>
)
